import Glide from '@glidejs/glide'

import '@glidejs/glide/dist/css/glide.core.min.css'
import '@glidejs/glide/dist/css/glide.theme.min.css'

if (!document.querySelector('#carousel-segredos-thumb')) {
  return
}

const glide_thumbs = new Glide('#carousel-segredos-thumb', {
  perView: 4.5,
  breakpoints: {
    1024: {
      perView: 2.5,
    },
    640: {
      perView: 1.2,
      peek: 24,
    },
  },
  gap: 16,
})

const glide = new Glide('#carousel-segredos', {
  swipeThreshold: false,
  dragThreshold: false,
})

glide_thumbs.mount()
glide.mount()

glide_thumbs.on('run', (e) => {
  glide.go(e.direction)
})
glide.on('run', (e) => {
  glide_thumbs.go(e.direction)
})

let current = 1
glide.on('run', (e) => {
  if (current == 10 && e.direction === '>') {
    current = 1
  } else if (current == 1 && e.direction === '<') {
    current = 10
  } else if (e.direction === '>') {
    current++
  } else {
    current--
  }
  document.querySelector('#current-segredo').innerHTML = current
})

const slides = document.querySelectorAll(
  '#carousel-segredos-thumb .glide__slide'
)
slides.forEach((slide) => {
  slide.addEventListener('click', () => {
    glide_thumbs.go('>')
  })
})
